import { AnswerType, ICategory } from "../models";

export const round98: ICategory[] = [
	{
		id: "1qxjhsok1sby64a",
		name: "Ghibli females",
		answers: [
			{
				id: "1qxjhsok1sby64f",
				type: AnswerType.TEXT,
				answer: "This female lead glides around and was first for doing so",
				question: "What is Nausciaa",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64k",
				type: AnswerType.TEXT,
				answer: "A character who works to save her family after a detour gone wrong",
				question: "What is Chihiro",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64p",
				type: AnswerType.TEXT,
				answer: "These two girls try to adjust to country living",
				question: "What is Mei and satsuki",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64u",
				type: AnswerType.TEXT,
				answer: "This Girl was adapted from the novel which shares this name",
				question: "What is Kiki",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64z",
				type: AnswerType.TEXT,
				answer:
					"One of the few films not to be directed by Mizayaki. The story follows this Princess",
				question: "What is Kaguya",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjhsok1sby64b",
		name: "Pompadorable",
		answers: [
			{
				id: "1qxjhsok1sby64g",
				type: AnswerType.TEXT,
				answer: "This character can be found at the local Boobies",
				question: "What is dandy",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64l",
				type: AnswerType.TEXT,
				answer: "This character may be Crazy. But he shines like a diamond",
				question: "What is Jojosuke",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64q",
				type: AnswerType.TEXT,
				answer: "This character from 'Danganronpa' has had their hair compared to a corn cob",
				question: "What is Mondo oowada",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64v",
				type: AnswerType.TEXT,
				answer: "His name is his weapon in 'One Punch man'",
				question: "What is metal bat",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby650",
				type: AnswerType.TEXT,
				answer: "This character was part of the awakening lab in mob psycho 100",
				question: "What is Hoshino",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjhsok1sby64c",
		name: "Jojo Parts",
		answers: [
			{
				id: "1qxjhsok1sby64h",
				type: AnswerType.TEXT,
				answer: "Steel ball run is a re-imagining of this part",
				question: "What is Phantom blood",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64m",
				type: AnswerType.TEXT,
				answer: "The only jojo part to have a female lead",
				question: "What is stone ocean",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64r",
				type: AnswerType.TEXT,
				answer: "'It just works' is a joke originating from this part",
				question: "What is vento aureo",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64w",
				type: AnswerType.TEXT,
				answer:
					"This part was only officially announced as part of jojo when it switched magazines",
				question: "What is steel ball run",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby651",
				type: AnswerType.TEXT,
				answer: "This part features a jojo who was part of the army, only for them to be murdered",
				question: "What is battle tendency",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjhsok1sby64d",
		name: "short and sweet",
		answers: [
			{
				id: "1qxjhsok1sby64i",
				type: AnswerType.TEXT,
				answer: "This series follows a cop in 3 minute episodes",
				question: "What is inferno cop",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64n",
				type: AnswerType.TEXT,
				answer: "Nova-kun is a key character in this show",
				question: "What is space patrol luluco",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64s",
				type: AnswerType.TEXT,
				answer: "this short series follows a shinobi during feudal japan",
				question: "What is Nobunaga no shinobi",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64x",
				type: AnswerType.TEXT,
				answer: "Sealand is featured in this series",
				question: "What is Hetalia",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby652",
				type: AnswerType.TEXT,
				answer: "This shows features statues as the main characters",
				question: "What is Sekkou boys",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjhsok1sby64e",
		name: "shoujo is Mahou",
		answers: [
			{
				id: "1qxjhsok1sby64j",
				type: AnswerType.TEXT,
				answer: "The first series of sailor moon is this many episodes",
				question: "What is 46",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64o",
				type: AnswerType.TEXT,
				answer: "Madoka magica is written by this unexpected writer",
				question: "What is Gen urobuchi",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64t",
				type: AnswerType.TEXT,
				answer: "This show is a spin off of the 'fate' series",
				question: "What is Fate/kaleid liner Prisma Illya",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby64y",
				type: AnswerType.TEXT,
				answer: "This mahou shouojo show was made into a movie by hideaki anno",
				question: "What is cutie honey",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjhsok1sby653",
				type: AnswerType.TEXT,
				answer: "Little witch academia's 'Akko' shares her name from this manga",
				question: "What is himitsu no akko-chan",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	}
];
